import 'rxjs/add/operator/map';

import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { userRole_globalAdmin, userRole_siteAdmin } from './../../Common/appConstant';
import { AppMessage } from './../../Common/appMessage';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { Enum } from './../../utility/enum.enum';
import { AdmBlacklistExamComponent } from './adm-blacklist-exam/adm-blacklist-exam.component';
import { AdmManageLocationSettingService } from './adm-manage-location-setting.service';

@Component({
  selector: 'app-adm-manage-location-setting',
  templateUrl: './adm-manage-location-setting.component.html',
  styleUrls: ['./adm-manage-location-setting.component.css'],
  providers: [AdmManageLocationSettingService]
})
export class AdmManageLocationSettingComponent implements OnInit {

  pageConfig: {
    resetFlag: boolean;  // Used this flag for Cascading dropdowns : Intially on page load - No cascading field should reset & After that If we change parent combo value - child should be reset
    isUpdateBtnDisable: boolean,
    showTimeError: any,
    invalidTime: boolean,
    showField: boolean
  };
  oldValues: { // set old values if User don't want to change location and click on NO of confirmation box
    region: string,
    location: string
  };
  role: string;
  locationId: number;
  days: any;
  weekStatus: any;
  form: FormGroup;
  formControl: any;
  regionFilteredOptions: any;
  locationFilteredOptions: any;
  countryFilteredOptions: any;
  keyboardTypeFilteredOptions: any;
  stateFilteredOptions: any;
  cityFilteredOptions: any;
  locationDetails: any = {};

  constructor(private _dialog: MdDialog, private _sharedService: SharedService, public _utility: Utility,
    private _admManageLocationSettingService: AdmManageLocationSettingService, private _fb: FormBuilder,
    private _activatedRoute: ActivatedRoute, private _appMessage: AppMessage, private _appGlobal: AppGlobals) {
    this.form = this._fb.group({
      regionId: new FormControl(''),
      countryId: new FormControl('', Validators.required),
      id: new FormControl('', Validators.required),
      locationName: new FormControl('', Validators.required),
      address1: new FormControl('', Validators.required),
      address2: new FormControl(''),
      stateId: new FormControl('', Validators.required),
      cityId: new FormControl('', Validators.required),
      zipcode: new FormControl('', Validators.required),
      keyboardTypeId: new FormControl('', Validators.required),
      timezone: new FormControl('', Validators.required),
      locationCalendarList: this._fb.array([]) // This is an form array where we have to build hours field dynamically
    });

    this.oldValues = {
      region: '',
      location: ''
    };

    this.formControl = this.form.controls;
    this.pageConfig = {
      resetFlag: false,
      isUpdateBtnDisable: false,
      showTimeError: {},
      invalidTime: false,
      showField: true
    }
    this.days = this._utility.days;

    this.form.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((values) => {
        if (values.id) {
          this.pageConfig.isUpdateBtnDisable = this._utility.disableSaveUpdate(this.form);
        }
        // If Changes detect then show a confirmation message of Unsaved data
        if (this.form.dirty) {
          this._utility.setTxnStatus(true);
        }
      });
    this.checkPermission();
  }


  /**
   * Check User Role
   * Hide Region field incase of role site admin or regional admin
   */
  checkPermission() {
    this.role = this._appGlobal.userInfo.getValue().userRole;
    if (this.role && this.role == userRole_globalAdmin) {
      this.form.controls.regionId.setValidators(Validators.required); //Make it required if role is global admin
      this.pageConfig.showField = true;
    } else {
      this.pageConfig.showField = false;
    }
  }

  initTimeField() {
    // initialize our address
    return this._fb.group({
      startTime: new FormControl('00:00', Validators.required),
      endTime: new FormControl('00:00', Validators.required),
      status: new FormControl('', Validators.required),
      weekDay: new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
    this._appGlobal.routeWithID = false;
    this.locationId = this._activatedRoute.snapshot.params['locationId'];
    if (!this.locationId) { this.locationId = 0 };


    // IF we are updating a particular location then disable location and region drodown
    if (this.locationId > 0) {
      this._utility.addLoaderCount();
      this.formControl.regionId.disable();
      this.formControl.id.disable();
    }
    // add address to the list
    const control = <FormArray>this.form.controls['locationCalendarList'];
    //Created dynamic Hours Fields
    for (let i = 0; i < this.days.length; i++) {
      control.push(this.initTimeField());
    }
    this.weekStatus = ['OPEN', 'CLOSE'];
    this.setCombosData();
    this.readFormControlValueChanges();
  }

  readFormControlValueChanges(): void {
    if (this.role == userRole_globalAdmin) {
      this.formControl.regionId.valueChanges
        .debounceTime(400)
        .distinctUntilChanged()
        .subscribe((value) => {
          if (!this.formControl.regionId.disabled) {
            this.regionChanges(value);
          }
        });
    }

    this.formControl.countryId.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.countryChages(value);
      });

    this.formControl.stateId.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.stateChages(value);
        this._utility.setTimeZone(value, this);
        ;
      });

    this.formControl.cityId.valueChanges
      .debounceTime(400)
      .subscribe((value) => {
        this._utility.setTimeZone(value, this);
        setTimeout(() => { this.pageConfig.resetFlag = true }, 1000);
      });

    // location change
    this.formControl.id.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        if (!this.formControl.id.disabled) {
          this.locationChange(value);
        }
      });
  }
  /**
   * Get Location setting details based on selected value
   * Assign selected Value Id into locationId variable
   * In case locationId and selected value id is same , means you selected same value so no need to hit any request
   * @param value - value which you have selected from location dropdown
   */
  locationChange(value) {
    if (!value) {
      this.locationId = 0; // if no value selected, no data should be display on below panels
      return;
    }
    if (value && value.id && value.id != this.locationId) {
      this.pageConfig.resetFlag = false; // make it false here so that Just after change location , child combos fields should not blank
      if (this.locationId == 0) {
        this.locationId = value.id;
        this.getLocationSettingData(value.id);
      } else {
        this._utility.showUnsavedChangesConfirmBox(() => {
          this.locationId = value.id;
          this.oldValues.location = value;
          this.getLocationSettingData(value.id);
        }, () => {
          // this function run when you click on cancel button
          this.form.controls.id.setValue(this.oldValues.location);
          this.pageConfig.resetFlag = true; // set resetFlag true so that child combos reset on change of parent
        });
      }
    }
  }

  setCombosData() {
    if (this._sharedService.countryList) {
      this._utility.setDataInComboField('country', null, this.formControl.countryId, this);
    }

    this._sharedService.getComboFieldsData(Enum.LocationName, (response) => {
      this._sharedService.locationList = response.response;
      this._utility.setDataInComboField('location', null, this.formControl.id, this);
      // Set value in field if there are single value
      if (this._sharedService.locationList.length == 1) {
        this.form.controls.id.setValue(this._sharedService.locationList[0]);
      }
    });

    // If global admin then  only load region field
    if (this.role == userRole_globalAdmin) {
      if (this._sharedService.regionList) {
        this._utility.setDataInComboField('region', null, this.formControl.regionId, this);
      } else {
        this._sharedService.getComboFieldsData(Enum.Region, (response) => {
          this._sharedService.regionList = response.response;
          this._utility.setDataInComboField('region', null, this.formControl.regionId, this);
        });
      }
    } else if (this.role == userRole_siteAdmin) {
      this.formControl.regionId.disable();
    }

    this._sharedService.getComboFieldsData(Enum.KeyboardType, (response) => {
      this._sharedService.keyboardTypeList = response.response;
      this._utility.setDataInComboField('keyboardType', null, this.formControl.keyboardTypeId, this);
    });

    this._sharedService.loadCountryStateCityData(); // Load country state and city combo data
    setTimeout(() => {
      if (this.locationId) {
        this._utility.removeLoaderCount();
        this.getLocationSettingData(this.locationId);
      }
    }, 500);

  }
  // when region Changes
  regionChanges(value) {
    // Reset cascading field only when resetFlag is true
    if (this.pageConfig.resetFlag) {
      this.formControl.id.setValue('');
      this.formControl.countryId.setValue('');
      this.formControl.cityId.setValue('');
      this.formControl.stateId.setValue('');
    }
    // If there is no any value in region field - display all locations
    if (!value) {
      this._utility.setDataInComboField('location', null, this.formControl.id, this);
      return;
    }
    if (value && value.id) {
      // Here we have to show locations based on selected region
      let param = "?outputType=" + Enum.LocationName + "&id=" + value.id + "&inputType=" + Enum.Region;
      this._sharedService.requestDataForCombo(param).subscribe((response: any) => {
        this._utility.onSuccessCallback(response, null, () => {
          this._utility.setDataInComboField('location', response.response.results, this.formControl.id, this);
        });
      });

      let data = this._sharedService.countryList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('country', data, this.formControl.countryId, this);
      }

    } else {
      this.locationFilteredOptions = null;
      this.countryFilteredOptions = null;
    }
  }


  // When country value changes
  countryChages(value: any) {
    if (this.pageConfig.resetFlag) {
      this.formControl.stateId.setValue('');
      this.formControl.cityId.setValue('');
    }
    if (value && value.id) {
      let data = this._sharedService.stateList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('state', data, this.formControl.stateId, this);
      }
    } else {
      this.stateFilteredOptions = null;
      this.cityFilteredOptions = null;
    }
  }

  // Called when status value Changes
  stateChages(value: any) {
    if (this.pageConfig.resetFlag) {
      this.formControl.cityId.setValue('');
    }
    if (value && value.id) {
      let data = this._sharedService.cityList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('city', data, this.formControl.cityId, this);
      }
    } else {
      this.cityFilteredOptions = null;
    }
  }

  // get Object from passed search field option
  // Based on Id we fetch that object from  Combo all data and return it,
  getValue(model: string, id: number): any {
    if (model && this._sharedService[model] && this._sharedService[model].length > 0) {
      let item = this._sharedService[model].filter((item) => { if (item.id == id) return item });
      return item[0];
    }
  }

  // Based on Dropdown Ids we fetch item from all data of dropdown and again set in to data object
  manageFormComboData(data) {
    if (data && data.id) {
      // For all combo fields fetch {Name and Id} from saved data based on coming Id and Update response
      let fields = Object.keys(data);
      for (var i = 0; i < fields.length; i++) {
        let field = fields[i];
        if (field == "locationCalendarList") {
          this.form.controls.locationCalendarList.patchValue(data[field]);
        }
        if (field.toLowerCase().substring(field.length - 2, field.length) == "id" && data[field]) {
          let prefix = field.substring(0, field.length - 2);
          if (field == 'id') {
            prefix = "location";  // TODO : Need  location Id in GET API to make it generic code (229)
          }
          if (prefix) {
            let obj = this._utility.getRecordById(prefix, data[field]);
            if (obj) {
              data[field] = obj;
            }
          }
        }
      }
    }

    // If role is Site admin or Regional admin then Load countries into country field.
    // For Global admin, coluntries will load based on region selection.
    if (this.role != userRole_globalAdmin) {
      this._utility.setDataInComboField('country', null, this.formControl.countryId, this);
    }
    return data;
  }

  getLocationSettingData(id: number) {
    this._utility.addLoaderCount();
    this._admManageLocationSettingService.getLocationSettingData(id).subscribe((response) => {
      this._utility.onSuccessCallback(response, null, () => { // we are passing second param as Null because we don't need to display any message here
        let data = response.response;
        this.locationDetails = data;
        let finalData = this.manageFormComboData(data);
        if (finalData) {
          this.form.patchValue(finalData);
          this.oldValues.location = finalData.id;
          this.oldValues.region = finalData.regionId;
        }
      });
    }, error => this._utility.onErrorCallback(error));
  }


  /* When we change time
    * Validate time : endtime should be greater than start time
    * If startTime > endTime --> make it true "pageConfig.showTimeError" for that particular index only
  */
  onTimeChange(startTime: any, endTime: any, i: number) {
    if (startTime != "" && endTime != "") {
      if (startTime > endTime) {
        this.pageConfig.showTimeError[i] = true;
        this.disableUpdate();
      } else {
        this.pageConfig.showTimeError[i] = false;
        this.disableUpdate();
      }
    } else {
      this.pageConfig.showTimeError[i] = false;
      this.disableUpdate();
    }
  }

  /**
   * If there are any invalid time validation in Hours panel then check that and make update button disable
   * If we change value of combo field and that is not exists in auto fill data then disable update button
   */
  disableUpdate() {
    // time validations
    let timeError = this.pageConfig.showTimeError;
    let data = this._utility.objValues(timeError).toString();
    if (data.toString().indexOf('true') > -1) {
      this.pageConfig.invalidTime = true;
    } else {
      this.pageConfig.invalidTime = false;
    }
  }

  /**
   * Called when dropdown value changes for Status.
   * If value is close then remove time validation for that particular index
   * If value is open then again call onTimeChange method to check validity
   * @param event - fetch current item
   * @param index  -- fetch index
   */
  onStatusChange(event: any, index: number) {
    if (event.value.toLowerCase() == 'close') {
      this.pageConfig.showTimeError[index] = false;
      this.disableUpdate();
    } else {
      let calenderControl = <any>this.form.controls.locationCalendarList;
      this.onTimeChange(calenderControl.controls[index].controls.startTime.value, calenderControl.controls[index].controls.endTime.value, index);
    }


  }

  onUpdateLocationSetting() {
    if (this.form.invalid) {
      return;
    }
    let formData = this.form.getRawValue();
    formData = this._utility.manageFormDataforSave(formData);
    this._utility.addLoaderCount();
    this._admManageLocationSettingService.updateLocationSetting(formData).subscribe(response => {
      this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00009'], () => {
        this._utility.clearTxnStatus();
        this._utility.removeLoaderCount();
      });
    }, error => this._utility.onErrorCallback(error));

  }

  onBlackListExam() {
    const dialogRef = this._dialog.open(AdmBlacklistExamComponent, {
      data: this.locationId
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }


  // This function is required to set Name value in autocomplete search fields
  // we are doing this because for Cascading combo and for save / update we need Id and for display we need Name property
  displayFn(option): string {
    if (option) {
      return option.name;
    }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-manage-location-setting.component.ts